<template>
  <div class="dashboard-container">
    <component :is="currentRole"></component>
    <el-dialog class="dialog-mini" width="500px" :title="'修改密码'" :visible.sync="dialogFormVisible"
               :close-on-click-modal="false" :append-to-body="true" :show-close="false">
      <el-form :rules="rules" ref="dataForm" :model="temp" label-position="right" label-width="100px">
        <p style="color: red;text-align: center;font-size: 14px">您的密码为初始密码，请重置密码</p>
        <el-form-item size="small" :label="'新密码'" prop="newPwd">
          <el-input v-model="temp.newPwd" show-password></el-input>
        </el-form-item>
        <el-form-item size="small" :label="'确认新密码'" prop="newPwd2">
          <el-input v-model="temp.newPwd2" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <!--        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>-->
        <el-button size="mini" type="primary" @click="passwordSubmit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import adminDashboard from './admin';
import { mapGetters } from 'vuex';
import * as users from '@/api/users';
import Cookies from 'js-cookie';

export default {
  name: 'dashboard',
  components: { adminDashboard },
  data() {
    const validateNewPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.temp.newPwd2 !== '') {
          this.$refs.dataForm.validateField('newPwd2');
        }
        callback();
      }
    };
    const validateNewPwd2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.temp.newPwd) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    };
    return {
      currentRole: 'adminDashboard',
      dialogFormVisible: false,
      rules: { // 校验规则
        newPwd: [{ required: true, trigger: 'blur', validator: validateNewPwd }],
        newPwd2: [{ required: true, trigger: 'blur', validator: validateNewPwd2 }]
      },
      temp: {
        id: '', // Id
        oldPwd: '123456', // 旧密码
        newPwd: '',
        newPwd2: '' // 新密码
      }
    };
  },
  computed: {
    ...mapGetters([
      'usid'
    ])
  },
  mounted() {
    if (Cookies.get('needChangePsd') === 'false') {
      this.dialogFormVisible = false;
    } else {
      this.dialogFormVisible = true;
    }
  },
  methods: {
    passwordSubmit() {
      this.temp.id = this.usid;
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          users.changePassword(this.temp).then(response => {
            this.dialogFormVisible = false;
            this.$notify({
              title: '成功',
              message: '密码修改成功',
              type: 'success',
              duration: 2000
            });
            if (this.temp.newPwd === '123456') {
              Cookies.set('needChangePsd', true);
              this.dialogFormVisible = true;
            } else {
              Cookies.set('needChangePsd', false);
            }
          });
        }
      });
    }
  }
};
</script>
